import { IBrand } from "containers/folders/types/brands";
import { handleActions } from "redux-actions";
import { BRANDS_DATA } from "constants/action-types";
import { IFetchStoreState, progressActions, initialFetchState } from "reducers/base-reducers";

export type IBrandData = Partial<IBrand> & { _id: string; name: string; active: boolean };

export interface IBrandsDataStatePayload {
    brandsDataById: { [_id: string]: IBrandData };
}

export type IBrandsDataState = IFetchStoreState<IBrandsDataStatePayload>;

/**
 * High performant request to fetch all brands.
 * Stores small amount of fields like `_id`, `name`, `active`.
 * For assortments it also stores `modules.assortment.active` field.
 *
 * @note use it only if you need to display a lot of brands. Brands stored here do **not** have `permissions` or other data.
 */
export const brandsData = handleActions<IBrandsDataState>(
    {
        ...progressActions(BRANDS_DATA.FETCH, "isFetching"),
    } as any,
    { ...initialFetchState, isFetching: false }
);
